import { useSiteConfig } from '../../context/SiteConfigContext';
import { useSEO } from '../../hooks/useSEO';
import { getPssManPrivacy } from '../../data/pssManPrivacy';
import styles from './PssManPrivacy.module.css';

// Unlike the other pages this is not a PageRenderer block tree: it renders
// fixed legal text from src/data/pssManPrivacy.js (see the note there).
function PssManPrivacy() {
  const config = useSiteConfig();
  const lang = config.meta.lang;
  const policy = getPssManPrivacy(lang);

  useSEO({
    title: policy.title,
    description: policy.intro[0],
    ogImage: config.meta.ogImage,
    lang,
  });

  return (
    <article className={styles.page}>
      <h1 className={styles.title}>{policy.title}</h1>
      <p className={styles.effective}>{policy.effective}</p>
      {policy.note && <p className={styles.note}>{policy.note}</p>}
      {policy.intro.map((text) => (
        <p key={text} className={styles.paragraph}>{text}</p>
      ))}
      {policy.sections.map((section) => (
        <section key={section.heading} className={styles.section}>
          <h2 className={styles.heading}>{section.heading}</h2>
          {(section.paragraphs || []).map((text) => (
            <p key={text} className={styles.paragraph}>{text}</p>
          ))}
          {section.bullets && (
            <ul className={styles.list}>
              {section.bullets.map((text) => (
                <li key={text}>{text}</li>
              ))}
            </ul>
          )}
          {section.email && (
            <p className={styles.paragraph}>
              <a className={styles.link} href={`mailto:${section.email}`}>{section.email}</a>
            </p>
          )}
        </section>
      ))}
    </article>
  );
}

export default PssManPrivacy;
